import React, { useState } from 'react';
import { Container, Row, Col, Button, Collapse } from 'react-bootstrap';

const SeoFooter = () => {
  const [showCities, setShowCities] = useState(false);
  const [showZips, setShowZips] = useState(false);
  const [showNeighborhoods, setShowNeighborhoods] = useState(false);

  return (
    <div className="bg-light py-5 border-top outline">
      <Container>
        <p className="mb-4">
          <strong>Additional Information About 4810 N Waltshire Ln, Mchenry, IL 60051</strong><br />
          4810 N Waltshire Ln, Mchenry, IL 60051 is a single family home for sale listed on the market for 4 days. 
          4810 N Waltshire Ln, Mchenry, IL 60051 is in the <a href="#">Windy Prairie Acres</a> neighborhood. 
          The schools near 4810 N Waltshire Ln include <a href="#">James C Bush Elementary School</a>, 
          <a href="#"> Johnsburg Jr High School</a> and <a href="#">Johnsburg High School</a>.
        </p>
        <Row>
          <Col md={4}>
            <h6>Nearby Cities</h6>
            <ul className="list-unstyled">
              <li>Crystal Lake Homes for Sale</li>
              <li>Johnsburg Homes for Sale</li>
              <li>Elgin Homes for Sale</li>
              <Collapse in={showCities}>
                <div>
                  <li>McHenry Homes for Sale</li>
                  <li>Fox Lake Homes for Sale</li>
                  <li>Woodstock Homes for Sale</li>
                </div>
              </Collapse>
            </ul>
            <Button variant="link" onClick={() => setShowCities(!showCities)} className="p-0">
              {showCities ? 'See less ▲' : 'See more ▼'}
            </Button>
          </Col>
          <Col md={4}>
            <h6>Nearby ZIPs</h6>
            <ul className="list-unstyled">
              <li>60010 Homes for Sale</li>
              <li>60014 Homes for Sale</li>
              <li>53147 Homes for Sale</li>
              <Collapse in={showZips}>
                <div>
                  <li>60051 Homes for Sale</li>
                  <li>60042 Homes for Sale</li>
                </div>
              </Collapse>
            </ul>
            <Button variant="link" onClick={() => setShowZips(!showZips)} className="p-0">
              {showZips ? 'See less ▲' : 'See more ▼'}
            </Button>
          </Col>
          <Col md={4}>
            <h6>Nearby Neighborhoods</h6>
            <ul className="list-unstyled">
              <li>Boone Valley Homes for Sale</li>
              <li>Far West Algonquin Homes for Sale</li>
              <li>Lakeland Park Homes for Sale</li>
              <Collapse in={showNeighborhoods}>
                <div>
                  <li>Windy Prairie Acres Homes for Sale</li>
                  <li>Downtown McHenry Homes for Sale</li>
                </div>
              </Collapse>
            </ul>
            <Button variant="link" onClick={() => setShowNeighborhoods(!showNeighborhoods)} className="p-0">
              {showNeighborhoods ? 'See less ▲' : 'See more ▼'}
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SeoFooter;